class UnexpectedValueError extends Error {
  override readonly name = "UnexpectedValueError";
}

/**
 * Useful for exhaustive switch
 */
export function assertNever(x: never, errorMessage?: string): never {
  throw new UnexpectedValueError(errorMessage ?? x);
}
